// Veriff's explainer on how candidate identity-verification data is handled,
// linked from the "How your data is used" note on the verification intro screen.
export const identityVerificationDataUsageLink =
  'https://www.veriff.com/fraud/learn/how-veriff-keeps-your-data-safe';
